module.exports = new __parcel__URL__("diamond3.a5b37d54.png").toString();